import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useApp } from "../../../app/context/useApp";
import ChatHistory from "../../../pages/Home/components/ChatHistory";
import QueryInput from "../../../pages/Home/components/QueryInput";
import ModeButtons from "../../../pages/Home/components/ModeButtons";
import {
  DESKTOP_CHAT_PADDING_X,
  DESKTOP_MODE_STRIP_PADDING_X,
  composerBottomPadSx,
  midDesktopSidebarClearanceSx,
  mobileNavMediaQuery,
  narrowChatSurfaceSx,
} from "../../../layout/layoutMetrics";
import { useSidebar } from "../../../layout/SidebarContext";

export default function BriefPage() {
  const { setActiveMode } = useApp();
  const { isSidebarOpen } = useSidebar();
  const midSidebarClearance = midDesktopSidebarClearanceSx(isSidebarOpen);

  useEffect(() => {
    return () => setActiveMode(null);
  }, [setActiveMode]);

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        height: "100%",
        position: "relative",
        display: "flex",
      }}
    >
      {/* <Background /> */}

      <Box
        sx={{
          flexGrow: 1,
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            mt: 0.5,
            px: DESKTOP_MODE_STRIP_PADDING_X,
            flexShrink: 0,
            [`@media ${mobileNavMediaQuery}`]: { px: 1.5 },
            ...midSidebarClearance,
          }}
        >
          <ModeButtons />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            minHeight: 0,
            overflowY: "auto",
            px: DESKTOP_MODE_STRIP_PADDING_X,
            [`@media ${mobileNavMediaQuery}`]: {
              overflowX: "hidden",
              px: 1.5,
            },
          }}
        >
          <ChatHistory showChatModeToggle />
        </Box>

        <Box
          sx={{
            px: { xs: 4, md: 20, lg: DESKTOP_CHAT_PADDING_X },
            pb: 1,
            pt: 2,
            flexShrink: 0,
            [`@media ${mobileNavMediaQuery}`]: {
              ...narrowChatSurfaceSx,
              ...composerBottomPadSx,
              minWidth: 0,
              width: "100%",
              boxSizing: "border-box",
            },
            ...midSidebarClearance,
          }}
        >
          <QueryInput />
        </Box>
      </Box>
    </Box>
  );
}